import { LocationStoreProvider } from '@/components/tabs/location-store-context';
import { Region } from '@/components/region';
import { readPageLocationName } from '@/lib/page-location';
import type { ContentPillarPageRouteData } from '@/content-routes/types';
import { fallback as pillarNavigationFallback } from '@/components/pillar-navigation/fallback';

export function ContentPillarPageRoute({ data }: { data: ContentPillarPageRouteData }) {
    const locationName = readPageLocationName(data.page) ?? null;

    return (
        <>
            <LocationStoreProvider store={null} locationName={locationName}>
                <Region
                    key={`${data.pageId}:pillarNavigation`}
                    page={data.page}
                    regionId="pillarNavigation"
                    fallbackElement={pillarNavigationFallback()}
                />
                <Region key={`${data.pageId}:content`} page={data.page} regionId="content" />
            </LocationStoreProvider>
        </>
    );
}
